import React from 'react';
import SearchContainer from '../containers/search/searchContainer';

export default function SearchPage(){
    return <SearchContainer/>
}